import AsControl from '../AsControl';
import bindControlToForm from '../../utils/hoc/formHelpers/bindControlToForm';
import autoSaved from '../../utils/hoc/formHelpers/autoSaved';
import { RadioButtonGroup as PureRadioButtonGroup } from './RadioButtonGroup';

export const RadioButtonGroup = AsControl()(PureRadioButtonGroup);
export const RadioButtonGroupControl = bindControlToForm()(RadioButtonGroup);
export const AutoSavedRadioButtonGroupControl = autoSaved({ saveOnChange: true })(RadioButtonGroupControl);
